import React from "react";

const cardStyle = {
  backgroundColor: "#ffffff",
  padding: "40px 30px",
  borderRadius: "15px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
  textAlign: "center",
  position: "relative",
  border: "1px solid #eef2f6",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};

const iconCircleStyle = {
  fontSize: "35px",
  marginBottom: "20px",
  width: "70px",
  height: "70px",
  backgroundColor: "#f0fdf4",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #dcfce7"
};

const cardTitleStyle = {
  color: "#0f2b46",
  fontSize: "22px",
  fontWeight: "800",
  marginBottom: "15px"
};

const cardParaStyle = {
  color: "#475569",
  lineHeight: "1.7",
  fontSize: "16px"
};

const accentLineStyle = {
  position: "absolute",
  bottom: "0",
  width: "50px",
  height: "4px",
  backgroundColor: "#22c55e",
  borderRadius: "10px 10px 0 0"
};

export default function About() {
  return (
    <div className="about-page">

      {/* WHO WE ARE */}
      <div className="about-container px-4 sm:px-6">
        
        {/* MOBILE FIX: column → DESKTOP untouched */}
        <div className="about-grid flex flex-col lg:grid lg:grid-cols-2 gap-10 items-center">
          
          <div className="about-text text-center lg:text-left">
            <h2 style={{ 
              fontSize: "42px", 
              fontWeight: "800", 
              marginBottom: "20px", 
              color: "#0f2b46" 
            }}>
              Who We <span style={{ color: "#22c55e" }}>Are</span>
              <div style={{ 
                width: "60px", 
                height: "4px", 
                backgroundColor: "#22c55e", 
                marginTop: "10px", 
                borderRadius: "2px" 
               }}></div>
            </h2>

            <p className="text-sm sm:text-base">
              <strong>Manoj V. Ayadi & Associates</strong>, a leading firm promoted by 
              Mr. Manoj V. Ayadi, is an integrated service law firm focused on corporate 
              laws. The firm renders legal advisory services and carries out various 
              types of due diligences, advising, organizing and implementing mergers, 
              demergers, compromises and arrangements.
            </p>

            <p className="text-sm sm:text-base">
              We provide expertise in capital market issues, public offers, acquisition 
              of shares, acquisition of control, and setting up of companies, partnership 
              firms and limited liability partnerships in India and abroad.
            </p>

            <p className="text-sm sm:text-base">
              Our firm also specializes in transaction advisory, documentation, 
              compliance management services, drafting share subscription agreements, 
              shareholders’ agreements, joint ventures and foreign collaborations.
            </p>

            <p className="text-sm sm:text-base">
              We assist in registration and protection of trademarks, product 
              registrations, passing off and infringement suits and appear before 
              Company Law Board, Debts Recovery Tribunals, Trademarks Tribunals, 
              Arbitral Tribunals, Intellectual Property Appellate Tribunals and 
              Securities Appellate Tribunals.
            </p>
          </div>

          {/* MOBILE FIX: remove translate */}
          <div className="about-image flex justify-center">
            <img
              src="https://www.canaveedmulla.com/images/llp_home.svg"
              alt="law office"
              className="w-full max-w-[300px] sm:max-w-[400px] lg:max-w-[450px] lg:-translate-y-[60px]"
            />
          </div>
        </div>
      </div>

      {/* MISSION SECTION */}
      <div className="mission-section py-12 sm:py-16 px-4 sm:px-6 bg-[#f4f7fa]">
        
        <div className="text-center mb-10 sm:mb-16">
          <h2 style={{ 
            fontSize: "32px", 
            fontWeight: "900", 
            color: "#0f2b46", 
            textTransform: "uppercase", 
            letterSpacing: "1px", 
            margin: "0" 
          }}>
            Our Mission & Values
          </h2>

          <div className="flex items-center justify-center mt-2">
            <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
            <div style={{ width: "100px", height: "14px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
            <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
          </div>
        </div>

        {/* MOBILE GRID FIX */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1200px] mx-auto">
          
          <div style={cardStyle}>
            <div style={iconCircleStyle}>🤝</div>
            <h3 style={cardTitleStyle}>Client Commitment</h3>
            <p style={cardParaStyle}>
              To consistently deliver outstanding services to our clients and
              provide fulfilling careers and professional satisfaction.
            </p>
            <div style={accentLineStyle}></div>
          </div>

          <div style={cardStyle}>
            <div style={iconCircleStyle}>🔍</div>
            <h3 style={cardTitleStyle}>Integrity & Transparency</h3>
            <p style={cardParaStyle}>
              We uphold the highest standards of integrity and transparency.
            </p>
            <div style={accentLineStyle}></div>
          </div>

          <div style={cardStyle}>
            <div style={iconCircleStyle}>📈</div>
            <h3 style={cardTitleStyle}>Client Growth</h3>
            <p style={cardParaStyle}>
              We believe our growth is directly related to client success.
            </p>
            <div style={accentLineStyle}></div>
          </div>

        </div>
      </div>
    </div>
  );
}